<div class="topHeader">
    <div class="container-fluid">
        <div class="upper_icon">
            <div class="position-relative">
                <i class="fa fa-bell notification_toggle" *ngIf="notifications.length == 0" aria-hidden="true" (click)="notfication()"></i>
                <img
                    *ngIf="notifications.length > 0"
                    (click)="notfication()"
                    src="../../../../../assets/media/logos/bell-icon-active.png"
                    alt="notification"
                    style="width: 24px; height: auto; margin-right: 20px; cursor: pointer; margin-top: 5px"
                />
                <div class="navabr_dropdownTwo" *ngIf="isNotificationDropdown">
                    <div class="navbar_dropdownTwoHead">
                        <h5>{{ 'NOTIFICATIONS.TITTLE' | transloco }}</h5>
                        <div class="notification-dropdown-wrapper">
                            <button class="btn primary-ebtn" *ngIf="notificationsFullList?.length">
                                {{ notificationsFullList.length }} {{ 'NOTIFICATIONS.NEW' | transloco }}
                            </button>
                            <span
                                class="mdi mdi-notification-clear-all notification-dropdown-clear-all"
                                (click)="clearAllNotification()"
                                matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.CLEAR_ALL' | transloco }}"
                                [matTooltipPosition]="'below'"
                            ></span>
                            <i
                                class="fas fa-cog notification-dropdown-setting"
                                style="color: black"
                                matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.NOTIFICATION_SETTINGS' | transloco }}"
                                [matTooltipPosition]="'below'"
                                (click)="openNotificationSettings()"
                            ></i>
                        </div>
                    </div>
                    <div class="navbar_dropdownTwobellHeight">
                        <div *ngIf="notifications.length > 0">
                            <div *ngFor="let noti of notifications; let i = index">
                                <div *ngIf="noti.notificationCheckType == 6; else notClickableNotification">
                                    <div class="navbar_dropdownTwobell pointer-link" (click)="notificationClick(noti)">
                                        <div class="round">
                                            <img src="../../../../../assets/media/logos/A_Rounded.png" style="height: 25px; width: 25px" />
                                        </div>
                                        <div class="notification_alert">
                                            <div class="notification-alert-wrapper">
                                                <h4>{{ noti.title }}</h4>
                                            </div>
                                            <p>{{ noti.message }}</p>
                                        </div>
                                    </div>
                                </div>
                                <ng-template #notClickableNotification>
                                    <div class="navbar_dropdownTwobell arrow-link">
                                        <div class="round">
                                            <img src="../../../../../assets/media/logos/A_Rounded.png" style="height: 25px; width: 25px" />
                                        </div>
                                        <div class="notification_alert">
                                            <div class="notification-alert-wrapper">
                                                <h4>{{ noti.title }}</h4>
                                                <i class="flaticon2-cross" (click)="NotifyNotification(noti)"></i>
                                            </div>
                                            <p>{{ noti.message }}</p>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                        <p class="no-data-found" *ngIf="notifications.length == 0">{{ 'NOTIFICATIONS.NO_NOTIFICATION_AVAILABLE' | transloco }}</p>
                        <!-- for all notification -->
                        <button (click)="open(mymodal1)" *ngIf="notificationsFullList.length > 5" (click)="notfication()">
                            {{ 'NOTIFICATIONS.SEE_ALL_NOTIFICATIONS' | transloco }}
                        </button>
                        <!-- all notification modal -->

                        <ng-template #mymodal1 let-modal>
                            <div class="modal-header head-tittle">
                                <div class="head-title-badge">
                                    <h4>{{ 'NOTIFICATIONS.TITTLE' | transloco }}</h4>
                                </div>
                                <div class="notification-wrapper pe-10">
                                    <button class="notification-badge1">{{ notificationsFullList.length }} {{ 'NOTIFICATIONS.NEW' | transloco }}</button>
                                    <span
                                        class="mdi mdi-notification-clear-all notification-clear"
                                        matTooltip="Clear All"
                                        [matTooltipPosition]="'below'"
                                        (click)="clearAllNotification()"
                                    ></span>
                                    <i
                                        class="fas fa-cog notification-setting"
                                        style="color: black"
                                        matTooltip="Notification Settings"
                                        [matTooltipPosition]="'below'"
                                        (click)="openNotificationSettings()"
                                    ></i>
                                    <a class="close-icon notification-close" href="javascript:void()" ngbAutofocus (click)="closeModel()"
                                        ><i class="flaticon2-cross"></i
                                    ></a>
                                </div>
                            </div>
                            <div class="modal-body notification-details">
                                <div *ngFor="let noti of notificationsFullList">
                                    <div *ngIf="noti.notificationCheckType == 6; else notClickableNotification">
                                        <div class="navbar_dropdownTwobell pointer-link" (click)="notificationClick(noti)">
                                            <div class="round">
                                                <img src="../../../../../assets/media/logos/A_Rounded.png" style="height: 25px; width: 25px" />
                                            </div>
                                            <div class="notification_alert">
                                                <div class="notification-alert-wrapper">
                                                    <h4>{{ noti.title }}</h4>
                                                </div>
                                                <p>{{ noti.message }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <ng-template #notClickableNotification>
                                        <div class="navbar_dropdownTwobell arrow-link">
                                            <div class="round">
                                                <img src="../../../../../assets/media/logos/A_Rounded.png" style="height: 25px; width: 25px" />
                                            </div>
                                            <div class="notification_alert">
                                                <div class="notification-alert-wrapper">
                                                    <h4>{{ noti.title }}</h4>
                                                    <i class="flaticon2-cross" (click)="NotifyNotification(noti)"></i>
                                                </div>
                                                <p>{{ noti.message }}</p>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div class="position-relative" *ngIf="accountName != ''">
                <a href="javascript:void(0)" (click)="navigateToSetting()"><i class="fa fa-cog" aria-hidden="true"></i></a>
            </div>

            <div class="position-relative">
                <i class="fa fa-user-circle user_toggle" aria-hidden="true" (click)="user()"></i>
                <div class="navbar_dropdownOne" *ngIf="isUserDropdown">
                    <div class="settings_links mt-3" *ngIf="getAccountName() == ''">
                        <a href="javascript:void(0)" class="btn font-weight-bold py-3 px-6" (click)="login()" i18n>{{
                            'LANDING_PAGE.BUTTONS_TEXT.LOGIN' | transloco
                        }}</a>
                    </div>

                    <div class="userProfile" *ngIf="accountName !== ''">
                        <div class="round">
                            <ngx-avatars name="{{ accountName }}" initialsSize="3" size="100" bgColor="#ffcc01" fgColor="#010101"></ngx-avatars>
                        </div>
                        <div class="settings_links mt-3" *ngIf="accountName != ''">
                            <h5>{{ accountName }}</h5>
                        </div>
                        <h6>{{ loggedInUserEmail }}</h6>
                        <div class="button-group mb-4">
                            <a [routerLink]="['/settings/profile']" class="me-1" *ngIf="isEditProfileEnabled">
                                <button class="btn primary-ebtn btn-rounded">{{ 'SETTING_PAGE.IDMS_SETTINGS.EDIT_PROFILE' | transloco }}</button>
                            </a>
                            <a href="javascript:void(0)" class="ms-1" *ngIf="accountName !== ''">
                                <button class="btn primary-ebtn btn-rounded" (click)="logout()">
                                    {{ 'SETTING_PAGE.IDMS_SETTINGS.SIGN_OUT' | transloco }}
                                </button>
                            </a>
                        </div>
                        <div class="administration_links mt-5" *ngIf="systemAdmin && currentOrgId">
                            <a href="avascript:void(0)" [routerLink]="['/management/edit-organization', currentOrgId]">
                                {{ 'SETTING_PAGE.IDMS_SETTINGS.ADMINISTRATION' | transloco }}</a
                            >
                        </div>
                        <div class="help_links">
                            <a href="avascript:void(0)" *ngIf="isEditProfileEnabled == true" [routerLink]="['/pricing']"
                                ><button class="btn secondary-ebtn btn-rounded">
                                    {{ 'SETTING_PAGE.IDMS_SETTINGS.PRICING_DETAILS' | transloco }}
                                </button></a
                            >
                            <a (click)="contactLinkClick()"
                                ><button class="btn secondary-ebtn btn-rounded">
                                    {{ 'SETTING_PAGE.IDMS_SETTINGS.CONTACT_US' | transloco }}
                                </button></a
                            >
                        </div>
                        <div class="bottom-section">
                            <div class="organization_section" *ngIf="currentOrg">
                                <div class="profile_img_div">
                                    <ngx-avatars name="{{ currentOrg }}" initialsSize="3" size="35" bgColor="#ffcc01" fgColor="#3F4254"></ngx-avatars>
                                </div>
                                <div class="organization_name">
                                    <p
                                        id="organization_name"
                                        class="name_trunc"
                                        [matTooltipDisabled]="!checkIsTextOverflow('organization_name')"
                                        matTooltip="{{ currentOrg }}"
                                    >
                                        {{ currentOrg }}
                                    </p>
                                    <a
                                        *ngIf="hideOrgLogout"
                                        [routerLink]="['/management/organization']"
                                        (click)="removeOrg()"
                                        [class.disabled]="canLogout === false"
                                        >{{ 'SETTING_PAGE.IDMS_SETTINGS.LOG_OUT' | transloco }}</a
                                    >
                                </div>
                            </div>
                            <div class="instance_section" *ngIf="currentInstance">
                                <div class="profile_img_div">
                                    <ngx-avatars name="{{ currentInstance }}" initialsSize="3" size="35" bgColor="#ffcc01" fgColor="#3F4254"></ngx-avatars>
                                </div>
                                <div class="instance_name">
                                    <p
                                        id="instance_name"
                                        class="name_trunc"
                                        [matTooltipDisabled]="!checkIsTextOverflow('instance_name')"
                                        matTooltip="{{ currentInstance }}"
                                    >
                                        {{ currentInstance }}
                                    </p>
                                    <a
                                        *ngIf="hideInstaceLogout"
                                        [routerLink]="['/management/instance']"
                                        [queryParams]="{ organizationId: [currentOrgId] }"
                                        (click)="removeInstance()"
                                        [class.disabled]="canLogout === false"
                                    >
                                        {{ 'SETTING_PAGE.IDMS_SETTINGS.LOG_OUT' | transloco }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
